import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Notifications6, {notify} from 'react-notify-toast';
import { get, post, put } from 'axios';
import { inject, observer } from 'mobx-react';
import InputRange from 'react-input-range';
import { sortable } from 'react-sortable';
import Dropzone from 'react-dropzone';
import 'react-input-range/lib/css/index.css';

class ServiceForm extends Component{
    constructor(props){
        super(props);
    }

    render(){
        const {service, handleInputChange, service_list, bus_srv_cat_list, handleCategoryChange} = this.props;
        return (
        <React.Fragment>
            <div className="form-group">
                <label>Name</label>
                <input className="form-control" name="name" type="text" onChange={handleInputChange} value={service.name}/>
            </div>
            <div className="form-group">
                <label>Description</label>
                <textarea className="form-control" name="description" onChange={handleInputChange} value={service.description}></textarea>
            </div>
            <div className="form-group">
                <label>Price</label>
                <input className="form-control" name="price" type="text" onChange={handleInputChange} value={service.price}/>
            </div>
            <div className="form-group">
                <label>Duration <small>in minutes</small></label>
                <InputRange
                    step={5}
                    maxValue={120}
                    minValue={5}
                    name="duration"
                    value={service.duration}
                    onChange={handleInputChange}
                />
            </div>
            <br/>
            <div className={String(service.preview_id) ==="0" ? "custom-control custom-checkbox" : "d-none"}>
                <input type="checkbox" className="custom-control-input" id="is_preview" name="is_preview" checked={service.is_preview} onChange={handleInputChange}/>
                <label className="custom-control-label" htmlFor="is_preview">This is a Preview service</label>
            </div>
            <div className={!service.is_preview ? "form-group" : "d-none"}>
                <label>If there is a preview service select below</label>
                <select className="form-control" name="preview_id" value={service.preview_id} onChange={handleInputChange}>
                    <option value="0">Select</option>
                    {service_list.map((service, index)=>{
                        if (service.is_preview){
                            return (<option value={service.id} key={index}>{service.name}</option>);
                        }
                    })}
                </select>
            </div>
            <div className={String(service.preview_id) !== "0"  && !service.is_preview ? "form-group" : "d-none"}>
                <label>Description of Preview <small>Optional description</small></label>
                <textarea className="form-control" name="preview_description" onChange={handleInputChange} value={service.preview_description}></textarea>
            </div>
            <div className={String(service.preview_id) !== "0"  && !service.is_preview ? "custom-control custom-checkbox" : "d-none"}>
                <input type="checkbox" className="custom-control-input" id="preview_required" name="preview_required" checked={service.preview_required} onChange={handleInputChange}/>
                <label className="custom-control-label" htmlFor="preview_required">This Preview service is required</label>
            </div>
            <div className="custom-control custom-checkbox">
                <input type="checkbox" className="custom-control-input" id="is_displayed" name="is_displayed" checked={service.is_displayed} onChange={handleInputChange}/>
                <label className="custom-control-label" htmlFor="is_displayed">Display service in Inquiry?</label>
            </div>
            <div className="custom-control custom-checkbox">
                <input type="checkbox" className="custom-control-input" id="is_display_admin" name="is_display_admin" checked={service.is_display_admin} onChange={handleInputChange}/>
                <label className="custom-control-label" htmlFor="is_display_admin">Hide in Service Add On?</label>
            </div>
            <div className="custom-control custom-checkbox">
                <input type="checkbox" className="custom-control-input" id="is_bridal" name="is_bridal" checked={service.is_bridal} onChange={handleInputChange}/>
                <label className="custom-control-label" htmlFor="is_bridal">Bridal Service?</label>
            </div>
            <h6 className="text-uppercase mt-3">Categories</h6>
            <p className="small">This organizes the services in the inquiry builder.</p>
            {bus_srv_cat_list.map((bus_srv_cat, index)=>
                <div key={index} className="custom-control custom-checkbox">
                    <input type="checkbox" className="custom-control-input" id={bus_srv_cat.id} name={bus_srv_cat.id} checked={service.bus_srv_cat_id_list.includes(bus_srv_cat.id)} onChange={handleCategoryChange}/>
                    <label className="custom-control-label" htmlFor={bus_srv_cat.id}>{bus_srv_cat.name}</label>
                </div>
            )}
        </React.Fragment>
        );
    }
}



class LineitemForm extends Component{
    constructor(props){
        super(props);
    }

    render(){
        const {lineitem, handleInputChange, sys_lineitem_type_list, sys_calculate_type_list} = this.props;
        return (
        <React.Fragment>
            <div className="form-group">
                <label>Name</label>
                <input className="form-control" name="name" type="text" onChange={handleInputChange} value={lineitem.name}/>
            </div>
            <div className="form-group">
                <label>Description</label>
                <textarea className="form-control" name="description" onChange={handleInputChange} value={lineitem.description}></textarea>
            </div>
            <div className="form-group">
                <label>Line Item Type</label>
                <select className="form-control" name="sys_lineitem_type_id" value={lineitem.sys_lineitem_type_id} onChange={handleInputChange}>
                    <option value="0">Select</option>
                    {sys_lineitem_type_list.map((type, index)=>
                        <option value={type.id} key={index}>{type.name}</option>
                    )}
                </select>
            </div>
            <div className="form-group">
                <label>Calculation Type</label>
                <select className="form-control" name="sys_calculate_type_id" value={lineitem.sys_calculate_type_id} onChange={handleInputChange}>
                    <option value="0">Select</option>
                    {sys_calculate_type_list.map((type, index)=>
                        <option value={type.id} key={index}>{type.description}</option>
                    )}
                </select>
            </div>
            <div className="form-group">
                <label>Amount</label>
                <input className="form-control" name="default_amount" type="text" onChange={handleInputChange} value={lineitem.default_amount}/>
                <p className="small">This will be dollar amount or percentage.  Use whole numbers only.</p>
            </div>
        </React.Fragment>
        );
    }
}

class ServiceItem extends React.Component {
  render() {
    const {bus_srv, index} = this.props;
    return (
      <div {...this.props} className="media cursor-pointer">
          <span className={String(bus_srv.sys_status_id) === "1" ? "avatar status-success" : "avatar status-danger"}>
              <img src={bus_srv.thumb} alt="..."/>
          </span>
          <div className="media-body" onClick={()=>this.props.setSelected(bus_srv, true)}>
              <p><strong>{bus_srv.name}</strong></p>
              <p>{bus_srv.description}</p>
              <p className="gap-items">
                  <small>Price: ${bus_srv.price}</small>
                  <small>Duration: {bus_srv.duration}m</small>
                  <small>Preview? {bus_srv.is_preview ? "YES" : "NO"}</small>
                  <small key={index}>Category: {bus_srv.bus_srv_cat_list.map((bus_srv_cat, cat_index)=><span key={cat_index}>{"{" + bus_srv_cat.name + "} "}</span>)}</small>
              </p>
          </div>
      </div>
    )
  }
}

var SortableItem = sortable(ServiceItem);

@inject('userStore')
class SettingsServices extends Component {
    constructor(props){
        super(props);
        this.state = {
            business:null,
            quickviewVisible:false,
            selectedItem:null,
            isService:true,
            component:null,
            bus_srv_list:[],
            bus_lineitem_list:[],
            files:[],
            uploadVisible:false,
            sys_lineitem_type_list:[],
            sys_calculate_type_list:[]
        }
        this.closeQuickview = this.closeQuickview.bind(this);
        this.setSelected = this.setSelected.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleCategoryChange = this.handleCategoryChange.bind(this);
        this.saveService = this.saveService.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.fileUpload = this.fileUpload.bind(this);
        this.addService = this.addService.bind(this);
        this.addLineitem = this.addLineitem.bind(this);
    }

    onSortItems = (items) => {
     this.setState({
       bus_srv_list: items
     },()=>{
       // reorder items
       put('/v2/service-order', {bus_srv_list:this.state.bus_srv_list},{auth: {username: this.props.userStore.token}
       }).then((res) => {
         console.log(res.data.message);
       });

     });
    }

    componentDidMount(){
        this.setState({
            business:this.props.business,
            bus_srv_list:this.props.business.bus_srv_list,
            bus_lineitem_list:this.props.business.bus_lineitem_list,
            sys_lineitem_type_list:this.props.sys_lineitem_type_list,
            sys_calculate_type_list:this.props.sys_calculate_type_list
        });
    }

    closeQuickview(){
        this.setState({
            quickviewVisible:false
            }, ()=>{this.setState({
                selectedItem:null
            })}
        );
    }

    addService(){
        this.setState({
            selectedItem:{id:0,name:"",service_type:"custom",business_id:this.state.business.id,description:"",price:0,duration:0,is_preview:false, preview_id:0, preview_required:false, is_displayed:false, is_bridal:false, bus_srv_cat_id_list:[],sys_status_id:1},
            isService:true
        }, ()=>{this.setState({quickviewVisible:true})})
    }

    addLineitem(){
        this.setState({
            selectedItem:{id:0,name:"",business_id:this.state.business.id,description:"",default_amount:0,sys_lineitem_type_id:0,sys_calculate_type_id:0},
            isService:false
        }, ()=>{this.setState({quickviewVisible:true})})
    }

    setSelected(item, isService){
        this.setState({
            selectedItem:item,
            isService:isService
        }, ()=>{this.setState({quickviewVisible:true})});
    }

    handleInputChange(e) {
        let updatedSelectedItem = Object.assign({}, this.state.selectedItem);
        if (e.target){
            const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
            updatedSelectedItem[e.target.name] = value;
        } else {
            updatedSelectedItem['duration'] = e;
        }
        this.setState({selectedItem:updatedSelectedItem});
    }

    handleCategoryChange(e) {
        let updatedSelectedItem = Object.assign({}, this.state.selectedItem);
        const checked = e.target.checked;
        if (checked){
            updatedSelectedItem.bus_srv_cat_id_list.push(parseInt(e.target.name));
        } else {
            let new_bus_cat_srv_id_list = updatedSelectedItem.bus_srv_cat_id_list.filter(id => e.target.name !== String(id));
            updatedSelectedItem.bus_srv_cat_id_list = new_bus_cat_srv_id_list;
        }
        this.setState({selectedItem:updatedSelectedItem});
    }

    saveService(){
        let updated_item = Object.assign({}, this.state.selectedItem);
        delete updated_item["sys_lineitem_type"];
        delete updated_item["sys_calculate_type"];
        let mode = 'edit';
        if (this.state.selectedItem.id === 0){
            mode = 'add';
        }
        post('/v2/save/bus_service', {item:updated_item, is_service:this.state.isService, mode:mode},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                if (this.state.isService){
                    let temp_bus_srv_list = Object.assign([], this.state.bus_srv_list);
                    if (mode === 'edit'){
                        let index = this.state.bus_srv_list.findIndex(x => x.id === this.state.selectedItem.id);
                        temp_bus_srv_list[index] = this.state.selectedItem;
                    } else {
                        temp_bus_srv_list.push(res.data.bus_srv);
                        this.setState({selectedItem:res.data.bus_srv});
                    }
                    this.setState({bus_srv_list:temp_bus_srv_list});
                } else {
                    let temp_bus_lineitem_list = Object.assign([], this.state.bus_lineitem_list);
                    if (mode === 'edit'){
                        let index = this.state.bus_lineitem_list.findIndex(x => x.id === this.state.selectedItem.id);
                        temp_bus_lineitem_list[index] = this.state.selectedItem;
                    } else {
                        temp_bus_lineitem_list.push(res.data.bus_lineitem);
                        this.setState({selectedItem:res.data.bus_lineitem});
                    }
                    this.setState({bus_lineitem_list:temp_bus_lineitem_list});
                }
                notify.show(res.data.message, "success", 3000);
            } else {
                notify.show(res.data.message, "error", 3000);
            }
        }).catch((error) => {
            notify.show(error, "error", 3000);
            console.log(error);
            return error;
        });
    }

    fileUpload(){
        const formData = new FormData();
        formData.append('file',this.state.files[0])
        formData.append('id', this.state.selectedItem.id)
        formData.append('typeof', 'bus_srv')
        post('/v2/upload/media', formData,{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                // set the new thumb image
                let index = this.state.bus_srv_list.findIndex(x => x.id === this.state.selectedItem.id);
                let temp_bus_srv_list = Object.assign([], this.state.bus_srv_list);
                let temp_bus_srv = Object.assign([], this.state.selectedItem);
                temp_bus_srv.thumb = res.data.src;
                temp_bus_srv_list[index] = temp_bus_srv;
                this.setState({
                    selectedItem:temp_bus_srv,
                    bus_srv_list:temp_bus_srv_list,
                    uploadVisible:!this.state.uploadVisible
                })
                notify.show(res.data.message, "success", 3000);
            } else {
                notify.show(res.data.message, "error", 3000);
            }
        }).catch((error) => {
            notify.show("Error occurred", "error", 3000);
            console.log(error);
            return error;
        });
    }

    onDrop(files) {
        console.log(files)
        this.setState({
              files:files
          }, ()=>this.fileUpload());
      }

      onCancel() {
      }

    openUpload = () => {
        this.setState({
            uploadVisible:!this.state.uploadVisible
        })
    }

    render(){
        const dropzone = {
            'position': 'relative',
            'width': '200px',
            'height': '200px',
            'borderWidth': '2px',
            'borderColor': 'rgb(102, 102, 102)',
            'borderStyle': 'dashed',
            'borderRadius': '5px',
            marginTop: '15px',
            marginRight: 'auto',
            marginBottom: 0,
            marginLeft: 'auto',
        };
        if (!this.state.business) return <div className="alert alert-info">Loading...</div>;
        var service_items = this.state.bus_srv_list.map((bus_srv, i) => {
              return (
                <SortableItem
                  key={i}
                  index={i}
                  setSelected={this.setSelected}
                  bus_srv={bus_srv}
                  onSortItems={this.onSortItems}
                  items={this.state.bus_srv_list}
                  sortId={i}/>
              );
            });
        return (
        <React.Fragment>
        <Notifications6 options={{wrapperId:'services-notifications'}}/>
        <div className={this.state.quickviewVisible ? "quickview quickview-lg reveal" : "quickview quickview-lg"}>
            {this.state.selectedItem ?
                <React.Fragment>
                    <header className="quickview-header">
                        <p className="quickview-title lead fw-400">{this.state.selectedItem.id !== 0 ? this.state.selectedItem.name : this.state.isService ? "Add New Service" : "Add New Line Item"}</p>
                        <span className="close" onClick={this.closeQuickview}><i className="ti-close"></i></span>
                    </header>
                    <PerfectScrollbar>
                    <div className="quickview-body ps-container ps-theme-default">
                        {this.state.isService && this.state.selectedItem.id !== 0 ?
                        <div className="card card-inverse mb-0">
                            <div className="card-body text-center pb-20 pt-20">
                                <img src={this.state.selectedItem.thumb} className="avatar avatar-xxl avatar-bordered" />
                                <br/>
                                <button className="btn btn-sm btn-primary mt-15" onClick={this.openUpload}>{this.state.uploadVisible ? "Close" : "Upload New Thumb"}</button>
                            <Dropzone
                                multiple={false}
                                onDrop={this.onDrop}
                                className={this.state.uploadVisible ? "" : "d-none"}
                                style={dropzone}
                                onFileDialogCancel={this.onCancel}>
                                <p>Drop a new image file here, or click to select file to upload.</p>
                          </Dropzone>
                            </div>
                        </div>
                        : null }
                        <div className="quickview-block">
                            {this.state.isService ? <ServiceForm service={this.state.selectedItem} handleInputChange={this.handleInputChange} handleCategoryChange={this.handleCategoryChange} service_list={this.state.business.bus_srv_list} bus_srv_cat_list={this.state.business.bus_srv_cat_list}/> : <LineitemForm handleInputChange={this.handleInputChange} lineitem={this.state.selectedItem} sys_calculate_type_list={this.state.sys_calculate_type_list} sys_lineitem_type_list={this.state.sys_lineitem_type_list}/>}
                        </div>
                    </div>
                    </PerfectScrollbar>
                    <footer className="quickview-footer flex-row-reverse">
                        <button className="btn btn-primary" type="submit" onClick={this.saveService}>Save</button>
                        <button className="btn btn-secondary" type="button" onClick={this.closeQuickview}>Cancel</button>
                    </footer>
                </React.Fragment>
            : <div>Loading</div> }
        </div>
        <div className="card">
            <ul className="nav nav-tabs nav-tabs-danger nav-justified" role="tablist">
                <li className="nav-item">
                    <a className="nav-link active" data-toggle="tab" href="#services" role="tab"><i className="fa fa-scissors"></i> Services</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" data-toggle="tab" href="#lineitems" role="tab"><i className="ion-pricetags"></i> Line Items</a>
                </li>
            </ul>
            <div className="tab-content">
                <div className="tab-pane fade active show" id="services">
                    <div className="media-list media-list-divided media-list-lg sortable-list">
                      {service_items}
                    </div>
                </div>
                <div className="tab-pane fade" id="lineitems">
                    <div className="media-list media-list-divided media-list-lg">
                    {this.state.bus_lineitem_list.map((bus_lineitem, index)=>
                        <div key={index} className="media cursor-pointer" onClick={()=>this.setSelected(bus_lineitem, false)}>
                            <div className="media-body">
                                <p><strong>{bus_lineitem.name}</strong></p>
                                <p>{bus_lineitem.description}</p>
                                <div className="media-block-actions">
                                    <nav className="nav nav-dot-separated">
                                        <span className="nav-link">{bus_lineitem.is_percentage ? bus_lineitem.default_amount + "%" : "$" + bus_lineitem.default_amount}</span>
                                        <span className="nav-link">{bus_lineitem.sys_calculate_type_description}</span>
                                    </nav>
                                </div>
                                <span></span>
                            </div>
                        </div>
                    )}
                    </div>
                </div>
            </div>
        </div>
        <div className="fab fab-fixed">
            <button className="btn btn-float btn-primary" data-toggle="button">
                <i className="fab-icon-default ti-plus"></i>
                <i className="fab-icon-active ti-close"></i>
            </button>
            <ul className="fab-buttons">
                <li><a className="btn btn-float btn-sm btn-info" href="#" title="" data-provide="tooltip" data-placement="left" data-original-title="Add new Service" onClick={this.addService}><i className="fa fa-scissors"></i></a></li>
                <li><a className="btn btn-float btn-sm btn-info" href="#" title="" data-provide="tooltip" data-placement="left" data-original-title="Add new Line Item" onClick={this.addLineitem}><i className="ion-pricetags"></i></a></li>
            </ul>
        </div>
        </React.Fragment>
        );
    }
}

export default SettingsServices;



// WEBPACK FOOTER //
// ./src/components/business/SettingsServices.js